<template>
  <modal
    name="custom-dialog"
    height="auto"
    :classes="['modal', 'is-active', params.class]"
    :width="width"
    :pivot-y="0.3"
    :adaptive="true"
    :click-to-close="false"
    :transition="transition"
    @before-open="beforeOpened"
    @before-close="beforeClosed"
    @opened="isModalOn"
    @closed="onClosed"
  >
    <!-- <div class="modal-background"></div> -->
    <div class="modal-card">
      <header class="modal-card-head">
        <p
          class="modal-card-title"
          v-html="params.title"
        />
        <button
          type="button"
          class="delete"
          aria-label="close"
          @click="$modal.hide('custom-dialog')"
        />
      </header>
      <section
        class="modal-card-body content m-b-none"
        tabindex="0"
      >
        <div v-html="params.text" />
        <component
          :is="form"
          ref="form"
        />
      </section>
      <footer
        v-if="buttons.length > 0"
        class="modal-card-foot is-justified-end p-sm"
      >
        <button
          v-for="(button, i) in buttons"
          :key="i"
          :class="[button.class, 'button', { 'is-loading': submitting }]"
          :disabled="submitting"
          type="button"
          @click.stop="click(i, $event)"
          v-html="button.title"
        >
          {{ button.title }}
        </button>
      </footer>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    width: {
      type: [ Number, String ],
      default: 400,
    },
    transition: {
      type: String,
      default: 'fade',
    },
  },
  data () {
    return {
      submitting: false,
      params: {},
      defaultButtons: [{ title: 'Close' }],
    };
  },
  computed: {
    buttons () {
      return this.params.buttons || this.defaultButtons;
    },
    form() {
      if (this.params.slots) {
        return this.params.slots.form || null;
      }
      return null;
    },
  },
  methods: {
    beforeOpened (event) {
      window.addEventListener('keyup', this.onKeyUp);
      this.params = event.params || {};
      this.$emit('before-opened', event);
    },
    beforeClosed (event) {
      window.removeEventListener('keyup', this.onKeyUp);
      this.$emit('before-closed', event);
    },
    async click (i, event, source = 'click') {
      const button = this.buttons[i];
      if (button && typeof button.handler === 'function') {
        if (button.submit) {
          if (this.$refs.form) {
            this.submitting = true;
            let response = await this.$refs.form.submit();
            console.log("response", response);
            if (! response) {
              this.submitting = false;
              console.log("Went throught false");
              return false;
            }
            this.submitting = false;
          }
        }
        console.log("Execute close handler");
        button.handler(button, event, { source });
      } else {
        this.$modal.hide('custom-dialog');
      }
    },
    onClosed($event) {
      if (typeof this.params.onClosed === 'function') {
        this.params.onClosed($event);
      }
      this.params = {};
      this.isModalOff($event);
    },
    onKeyUp (event) {
      if (event.which === 13 && this.buttons.length > 0) {
        const buttonIndex =
          this.buttons.length === 1
            ? 0
            : this.buttons.findIndex(button => button.default);
        if (buttonIndex !== -1) {
          this.click(buttonIndex, event, 'keypress');
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .modal-card {
    max-width: 100%;
  }
</style>